var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ExActionsPopUp',{attrs:{"value":_vm.show,"headline":"Activate Employee","avatar":_vm.avatar,"htmlInfo":_vm.formattedInfo,"centerHeadline":true,"actionsTopSpacing":"32px"},on:{"input":function($event){return _vm.$emit('onClose')},"onAction":function($event){return _vm.$emit('onActiveEmployee')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }